import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=094691c4&scoped=true&lang=pug"
import script from "./Partners.vue?vue&type=script&lang=ts"
export * from "./Partners.vue?vue&type=script&lang=ts"
import style0 from "./Partners.vue?vue&type=style&index=0&id=094691c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094691c4",
  null
  
)

export default component.exports